module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 261
// module chunks = 8 10 11 13 22 23 41